import { render, staticRenderFns } from "./SortingProduct.vue?vue&type=template&id=5739a9c5&scoped=true"
import script from "./SortingProduct.vue?vue&type=script&lang=js"
export * from "./SortingProduct.vue?vue&type=script&lang=js"
import style0 from "./SortingProduct.vue?vue&type=style&index=0&id=5739a9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5739a9c5",
  null
  
)

export default component.exports